<template>
    <div class="modal" id="termscouponModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true" v-if="coupon">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel">Términos y condiciones</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="font-icons icons-close"></i></span>
                    </button>
                </div>

                <div class="modal-body">

                    <p>
                        {{ coupon.description }}
                    </p>

                    <p>
                        {{ coupon.termsAndConditions }}
                    </p>

                </div>

            </div>
        </div>
    </div>
</template>


<script>


export default {
    props: {
        coupon: null
    },
    data() {
        return {
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>